const dataAttributes = require("data-attributes");
const window = require("global/window");
const doc = require("global/document");

const el = doc.getElementById(__SETUP_TAG_ID__);

window.__WEBPACK_SETUP_DATA__ = dataAttributes(el);

// As is described at https://webpack.js.org/configuration/output/#output-publicpath:
// > In cases where the publicPath of output files can't be known at compile time, it can be left blank and set
// > dynamically at runtime in the entry file using the free variable __webpack_public_path__.
//
// This setting is respected by both dynamic imports and by the file-loader.
__webpack_public_path__ = `${window.__WEBPACK_SETUP_DATA__.assetUrl}/`;
